export const environment = {
  production: false,

  oaiboxTelemetryExpiryMs: 10 * 1000,
  defaultFlexRicOfflineMs: 10 * 1000,

  apiBasePath: 'https://api.oaibox.allbesmart.pro',
  dashboardBasePath: 'https://my.oaibox.allbesmart.pro',
  labkitRegisterUrl: 'https://register.academy.allbesmart.pt',

  ws: {
    brokerUrl: 'wss://api.oaibox.allbesmart.pro/ws/websocket',
    heartbeatIncoming: 1000,
  },

  keycloak: {
    url: `https://auth.allbesmart.pro`,
    realm: 'OAIBOX',
    clientId: 'OAIBOX-API',
  },
}
